import { filtersToQueryString } from "../utils/post-filter";
import client from "./ApiService";

class PostService {
  constructor() {
    this.url = "/posts";
  }
  get(filters = {}, getAll = false, getByPublishedAt = false) {
    if (!filters._limit) {
      filters._limit = { fieldName: "_limit", value: 10 };
    }

    let queryString = filtersToQueryString(filters, getAll, getByPublishedAt);

    if (queryString.indexOf("&") == 0) {
      queryString = queryString.replace("&", "?");
    }
    console.log(queryString);
    return client.get(`${this.url}${queryString}`);
  }

  getByBtv(btvSlug){

  }

  update(params){
    return client.put(`${this.url}/${params.id}`, params);
  }

  updatelock(params){
    return client.put(`${this.url}/lock/${params.id}`, params);
  }

  getById(id){
    return client.get(`${this.url}/${id}`);
  }

  deletePost(id){
    return client.delete(`${this.url}/${id}`);
  }
}

export default new PostService();
